var constant = {
  access_token: 'ACCESS_TOKEN',
  refresh_token: 'REFRESH_TOKEN',
  expires_in: 'EXPIRES_IN',
  token_expires_time: 'TOKEN_EXPIRES_TIME',
  user_info: 'USER_INFO',
  user_name: 'USER_NAME',
  sessionId: 'sessionId'
};
export default constant;